import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "@/components/ui/tooltip";

interface Props extends React.ComponentProps<typeof Button> {
  tooltip?: React.ReactNode;
  children: React.ReactNode;
}

export const TooltipButton = (props: Props): React.ReactNode => {
  return (
    <div className="flex items-center gap-2">
      <Tooltip open={props.tooltip && props.disabled ? undefined : false}>
        <TooltipTrigger asChild>
          <div className="w-full">
            <Button {...props}>{props.children}</Button>
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>{props.tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </div>
  );
};
